import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom"
import AuthRouter from './routers/AuthRouter'
import { AuthProvider } from './components/auth/useAuth'
import PrivateAdminRouter from './routers/PrivateAdminRouter'
import AdminRouter from './routers/AdminRouter'
import PrivateLaboratoryRouter from './routers/PrivateLaboratoryRouter'
import LaboratoryRouter from './routers/LaboratoryRouter'

export default function App() {
	return (
		<>
			<BrowserRouter>
				<AuthProvider>
					<Routes>
						<Route path="/admin/*" element={ <PrivateAdminRouter><AdminRouter /></PrivateAdminRouter>} />
						<Route path="/laboratory/*" element={ <PrivateLaboratoryRouter><LaboratoryRouter /></PrivateLaboratoryRouter>} />
						<Route path="*" element={<AuthRouter />}/>
					</Routes>
				</AuthProvider>
			</BrowserRouter>
		</>
	)
}